export const HYDRO_STYLE_HEADER_FILTER = 80
export const HYDRO_STYLE_PADDING = 20
